import {BaseWebsiteResource} from "./base-website-resource";
import {Menu} from "./menu";

export class SpecialPages extends BaseWebsiteResource {

  public agbPage: Menu | null;
  public pricingPage: Menu | null;

  constructor(el: any = {}) {
    super(el);

    this.agbPage = el.agbPage ? new Menu(el.agbPage) : null;
    this.pricingPage = el.pricingPage ? new Menu(el.pricingPage) : null;
  }

  public override toJson(): any {
    return {
      ...super.toJson(),

      agbPage: this.agbPage?.toJson(),
      pricingPage: this.pricingPage?.toJson(),
    };
  }

  public override clone(): SpecialPages {
    return new SpecialPages({...this.toJson(), id: undefined});
  }
}
